import { render, staticRenderFns } from "./CancelSubmitButton.vue?vue&type=template&id=6f7a4cf5"
import script from "./CancelSubmitButton.vue?vue&type=script&lang=js"
export * from "./CancelSubmitButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports